export const keepDataPerSeconds = {
    payslipPeriodApi: 120,
    payslipApi: 120,
    payslipSocialBenefitApi: 300,
    yearPeriodApi: 300,
    employeeContractLiquidationApi: 120,
};
